import { IPermissionsContext } from "../../ipermissions-context/ipermissions-context.interface";
import { IPermissions } from "../../ipermissions/ipermissions.interface";
import { hasUserGroup } from "../../ipermissions-context/ipermissions-context.functions";
import { UserGroup } from "../../../../../constants/types";
import { enablePermissions } from "../../ipermissions/ipermissions.functions";
import { IPermissionPolicyEvaluator } from "../../ipermissions/ipermission-policy.type";

export const productionCoordinatorGroupPolicy = (next?: IPermissionPolicyEvaluator) => (
  context: IPermissionsContext,
  permissions: IPermissions
) => {
  if (hasUserGroup(context, UserGroup.PRODUCTION_COORDINATORS)) {
    enablePermissions(permissions, "canCreateFlyer");
  }

  if (next) {
    return next(context, permissions);
  }
};
